module.exports = __webpack_public_path__ + "img/vehicleCircleBus.2319f14a.svg";